@if (this.loaders.default) {
  <div class="loader-container">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <div class="p-4 box" [formGroup]="formGroup">
    <app-dropdown
      [multiple]="false"
      [searchable]="true"
      [clearable]="true"
      [isVertical]="true"
      [hasImg]="true"
      [items]="channels"
      bindValue="id"
      bindLabel="name"
      [formControl]="formGroup.controls.channel_id"
      [placeholder]="'channel_not_selected' | translate"
      (onValueChange)="channelSelected()"
      class="channel-dropdown"
    />

    @if (isShowSendMessage) {
      <app-text-field
        [type]="'v2'"
        [formControl]="formGroup.controls.chat_name"
        label="chat_name" />

      @if (formGroup.controls.phone) {
        <app-input
          labelType="floating"
          [variant]="'on'"
          [inputType]="'phone'"
          [formControl]='formGroup.controls.phone'
          [id]="'phone'"
          [invalid]="formGroup.controls.phone.invalid && formGroup.controls.phone.touched"
          [options]="PHONES_FOR_INPUT"
          [optionValue]="'value'"
          [optionLabel]="'title'"
        />
      }

      @if (formGroup.controls.username) {
        <app-text-field
          class="username-field"
          [type]="'v2'"
          [formControl]="formGroup.controls.username"
          label="username"
          placeholder="@username"
          [isPlaceholderTranslate]="false" />
      }

      <app-button class="create-chat-btn" (onChangeClick)="writeMessage()">
        {{ 'write_message' | translate }}
      </app-button>
    }


  </div>
</ng-template>
